export const POPUP_EVENTS = {
  CLOSE: 'popup-close',
};
